import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getMsisdnStatuses = async (token) => {
    log("welcome in getMsisdnStatuses")

    if (!token || token === "") {
        return {error: true, message: "No token provided", msisdn_statuses: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_msisdn_statuses_api'
        const result = await axios.get(url, {headers: headers})
        return result.data
    } catch (err) {
        log("Error in getMsisdnStatuses")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getMsisdnStatuses", msisdn_statuses: []}
    }
}

export default () => {
    return {
        error,
        getMsisdnStatuses
    }
}
